import { observer } from "@legendapp/state/react";
import { AnimatePresence, motion } from "motion/react";
import { MouseEvent, useCallback, useEffect, useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';
import NavItems from '../../../../state/staticItems';
import "./header.nav.scss";


export interface IHeaderNav {
  isTopNav?: boolean,
  customClass?: string,
  isMenuVisible: boolean,
  requestToggleMenu: (state: boolean) => void
}

const HeaderNav = observer(({ isTopNav, customClass, isMenuVisible, requestToggleMenu }: IHeaderNav) => {
  const { pathname } = useLocation();

  const [isCurrentPathNameVisible, setCurrentPathNameVisible] = useState(false);
  const [currentPathName, setActivePathName] = useState('');

  const findPathName = useCallback((pathname: string) => {
    if (!pathname) {
      return '';
    }

    if (pathname === '/') {
      return 'Home';
    }

    const currentItem = NavItems.filter(item => item.name !== 'Home').find(item => pathname.includes(item.path));

    if (!currentItem) {
      return ''
    }

    return currentItem.name
  }, []);

  useEffect(() => {
    const newPathName = findPathName(pathname);

    if (newPathName !== currentPathName) {
      setCurrentPathNameVisible(false);

      setTimeout(() => {
        setActivePathName(findPathName(pathname));
        setCurrentPathNameVisible(true);
      }, 300);
    }
  }, [pathname, currentPathName, findPathName, setActivePathName, setCurrentPathNameVisible])

  return (
    <nav role="navigation" className={`header-navigation ${customClass || ''}`}>
      <div className={`header-navigation__container ${isMenuVisible ? 'header-navigation__container--visible' : ''}`} onClick={() => {
        requestToggleMenu(false);
      }}>
        <ul className={`list d-flex ${!isTopNav ? 'f-wrap' : ''}`}>
          {
            NavItems.map((item) => (
              <li key={item.path}>
                <NavLink to={item.path}
                  className={({ isActive }) => 'header-navigation__link' + (isActive ? ' header-navigation__link--active' : '')}
                  onClick={(event) => {
                    handleNavLinkClick(event, item.path);
                  }}>
                  <span className="header-navigation__description">
                    {item.name}
                  </span>
                </NavLink>
              </li>
            ))
          }
        </ul>
      </div>

      <div className={'active-nav'}>
        <AnimatePresence>
          {isCurrentPathNameVisible && (
            <motion.button
              type="button"
              className={'active-nav__element btn--reset'}
              onClick={() => requestToggleMenu(true)}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.25 }}
            >
              {currentPathName}
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </nav>
  )

  function handleNavLinkClick(event: MouseEvent<HTMLAnchorElement>, path: string) {
    requestToggleMenu(false);

    if ((pathname !== '/' && path === '/') ||
      (pathname === '/' && path !== '/')) {
      return;
    }

    if (!pathname ||
      !path ||
      !pathname.toLowerCase().includes(path.toLowerCase())) {
      return handleCancelRequests(pathname);
    }

    event.preventDefault();
  }

  function handleCancelRequests(path: string) {
    switch (path) {
      // case INavPaths.CLAUSE_TYPE: {
      //   return dispatch(startCancelClauseTypeDataFetch());
      // }

      default: return;
    }
  }
})

export default HeaderNav;
